import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTask = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M30,0A30,30,0,1,1,0,30,30,30,0,0,1,30,0Z",
			fill: "#fff",
			opacity: .655
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17.5,
			y: 19.5,
			width: 25,
			height: 23,
			rx: 1.5,
			fill: "#d9daee",
			stroke: "#7284fa",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 17.5,
			y1: 25.5,
			x2: 42.5,
			y2: 25.5,
			fill: "none",
			stroke: "#7284fa",
			strokeLinecap: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 22.5,
			y: 16.5,
			width: 2.5,
			height: 5,
			fill: "#d9daee",
			stroke: "#7284fa",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 35,
			y: 16.5,
			width: 2.5,
			height: 5,
			fill: "#d9daee",
			stroke: "#7284fa",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("polyline", {
			points: "25,33.5 28.5,37 35,30.5",
			fill: "none",
			stroke: "#7284fa",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		})
	]
});
export default SvgTask;
